<template>
    <v-dialog
      v-model="dialog"
      :max-width="options.width"
      :style="{ zIndex: options.zIndex }"
      @keydown.esc="close"
    >
      <v-card>
        <v-card-title class="px-10 pt-4">
            <h2>Fragenübersicht</h2> 
            <v-spacer /> 
            <v-btn icon @click="close">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            </v-card-title>
                <v-main style="min-height:300px;margin:5px;" class="pa-0 px-10">
                <v-expansion-panels focusable flat v-if="(schema && schema.pages)">
                    <v-expansion-panel
                      v-for="page in schema.pages"
                      :key="page.name"
                      class="border-bottom"
                    >
                      <v-expansion-panel-header class="text-semibold text-gray" style="align-items: start;
                      justify-content: flex-start">
                        <span :class="'element-title '+getElementIcon(page.name)"/> <span class="ml-4">{{page
                          .title}}</span>
                        <v-spacer/>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-list-item v-for="question in page.questions" :key="question.name">
<!--                           <v-list-item-icon>
                            <v-icon color="primary">mdi-help-network-outline</v-icon>
                          </v-list-item-icon> -->
                          <v-list-item-content>
                            <v-row>
                              <v-col cols="2">
                                <v-chip small label outlined color="lightblue" class="overview-question-label">
                                  Frage {{page.questions.indexOf(question) +1}}
                                </v-chip>
                              </v-col>
                              <v-col cols="10">
                                <p class="overview-question-text">
                                  {{ getQuestionText(question) }}
                                </p>
                              </v-col>
                            </v-row>
                          </v-list-item-content>
                        </v-list-item>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                  <div v-if="schema && schema.pages && schema.pages.length == 0" class="d-flex flex-column items-center justify-center">
                    <div class="d-flex justify-center mt-10" style="opacity: .5;">
                      <svg width="91" height="89" viewBox="0 0 91 89" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <ellipse cx="56.7279" cy="52.2381" rx="29.7279" ry="31.2381" fill="#F1F1F1"/>
                        <g clip-path="url(#clip0_3416_18314)">
                          <path d="M36 71.25C55.468 71.25 71.25 55.468 71.25 36C71.25 16.532 55.468 0.75 36 0.75C16.532 0.75 0.75 16.532 0.75 36C0.75 55.468 16.532 71.25 36 71.25Z" stroke="#B7B7B7" stroke-width="1.5" stroke-miterlimit="10"/>
                          <path d="M36 63.96C51.4419 63.96 63.96 51.4419 63.96 36C63.96 20.5582 51.4419 8.04004 36 8.04004C20.5582 8.04004 8.04004 20.5582 8.04004 36C8.04004 51.4419 20.5582 63.96 36 63.96Z" stroke="#B7B7B7" stroke-width="1.5" stroke-miterlimit="10"/>
                          <path d="M51.7999 20.2L20.2 51.7999" stroke="#929CA9" stroke-width="1.5" stroke-miterlimit="10"/>
                          <path d="M20.2 20.2L51.7999 51.7999" stroke="#929CA9" stroke-width="1.5" stroke-miterlimit="10"/>
                        </g>
                        <defs>
                          <clipPath id="clip0_3416_18314">
                            <rect width="72" height="72" fill="white"/>
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <p class="text-center font-s text-gray mt-4">
                      Noch keine Fragen angehängt
                    </p>
                  </div>
                </v-main>
                 <v-card-actions class="bg-gray pr-6 pb-6">
                   <v-btn color="tr_red" text small @click="resetQuestions">
                     <v-icon small>mdi-refresh</v-icon>Alle Fragen zurücksetzen
                   </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn text @click.stop="close" color="gray_3">Schließen</v-btn>
                    <v-btn @click.stop="generateSurvey" color="primary" elevation="0">Umfrage generieren</v-btn>
                </v-card-actions>
            </v-card>
       
    </v-dialog>
  </template>
  
  <script>
import pxQuestionProcessService from '../PxQuestionSection/px-question-process-service';

  export default {
    name: "FormDlg",
    data() {
      return {
        dialog: false,
        resolve: null,
        reject: null,
        schema: null,
        options: {
          width: 800,
          height: 500,
          zIndex: 200,
        }
      };
    },
  
    methods: {
      open(schema) {
        this.schema = schema;
        this.dialog = true;
        return new Promise((resolve, reject) => {
          this.resolve = resolve;
          this.reject = reject;
        });
      },
      close() {
        this.resolve();
        this.dialog = false;
      },
      getElementIcon(id){
        if(id.includes("Pool")){
          return "bpmn-icon-participant";
        }else if(id.includes("Lane")){
          return "bpmn-icon-lane-divide-two";
        }else if(id.includes("Activity")){
          return "bpmn-icon-call-activity";
        }else if(id.includes("Gateway")){
          return "bpmn-icon-gateway-none";
        }else if(id.includes("Flow")){
          return "bpmn-icon-connection";
        }else if(id.includes("Event")){
          return "bpmn-icon-start-event-none";
        }else if(id.includes("DataObject")){
          return "bpmn-icon-data-object";
        }else if(id.includes("DataStore")){
          return "bpmn-icon-data-store";
        } 
      },
      getQuestionText(question){
        if(question.rows != null) return question.rows[0].text;
      },
      generateSurvey(){
        this.$emit("generateSurvey");
      },
      async resetQuestions(){

        await this.schema.pages.forEach(async page => {
            await page.questions.forEach(async question => {
                let [questionId, ...tmp] = question.name.split("_");
                let elementId = tmp.join("_");
                await pxQuestionProcessService.removeQuestionFromElement(this.schema.uuid, elementId, questionId);
            })
        });
        this.close();
        this.$emit("questionsChanged");
       
      }
    }
  };
  </script>
<style>
.element-title {
  flex: unset !important;
}
:deep .v-chip__content {
  display: flex !important;
}
.v-expansion-panel-content {
  margin-top: 20px;
}
.overview-question-label {
  font-weight: 600;
  font-size: 10px !important;
  text-transform: uppercase;
  letter-spacing: 1px;
  padding: 2px 6px !important;
}
.overview-question-text {
  margin-left: -32px;
  margin-top: 3px;
  font-size: 0.8rem;
  line-height: 1.6;
}
</style>